<template>
    <transition
            :appear="appear"
            name="slideToggle"
            mode="out-in"
            @beforeAppear="beforeEnter"
            @beforeEnter="beforeEnter"
            @afterAppear="afterEnter"
            @afterEnter="afterEnter"
            @leave="leave"
            :css="false">
        <slot></slot>
    </transition>
</template>
<script>
  /* ============
   * SlideToggle Transition Component
   * ============
   *
   * JQuery slide toggle transition
   */
  import $ from 'jquery'

  export default {
    props: {
      appear: {
        type: Boolean,
        default: true
      },
      duration: {
        type: Number,
        default: 300
      }
    },
    methods: {
      beforeEnter (el) {
        el.style.display = 'none'
      },
      afterEnter (el) {
        this.$nextTick(() => {
          $(el).slideDown(this.duration)
        })
      },
      leave (el, done) {
        // leave animation
        $(el).slideUp(this.duration, () => {
          done()
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/transitions/SlideToggleTransition.vue